// if locale is GB, show a motivator bar
// motivator bar should count up to £50 = 100%

//alert("hello from motivator!");
//console.log("hello from motivator with country_code "+country_code+"!");

var enable_custom_motivator = true;
//var enable_custom_motivator = false;
var free_shipping_at = 5000;    // in pence!

//alert("hello " + country_code);

if (country_code == 'GB' && enable_custom_motivator) {
    //alert("hello there GB");
    function refresh_motivator() {
        $.ajax({
            type: 'GET',
            url: routes.cart_url,
            cache: false,
            dataType: 'json',
            success: function(cart) {
                //console.log("cart-3dt!");
                do_motivator_bar(cart);
                // whatever you want to do with the cart obj
            }
        }); 
    }

    var bar1;

    function update_motivator_bar(cart) {
        //alert("update_motivator_bar");
        //console.log("update_motivator_bar!");
        //console.log(cart);

        percent_complete = (cart.total_price/free_shipping_at) * 100;
        bar1.style.setProperty('--pss-value', percent_complete);

        // update the text inside the bar
        if (percent_complete==0) {
            document.getElementById('motivator_bar').innerText = "Cart empty";
        } else if (percent_complete>=100) {
            document.getElementById('motivator_bar').innerText = "Free UK shipping unlocked!";
        } else {
            document.getElementById('motivator_bar').innerText = "";
        }

        // update the message above the bar
        if (percent_complete>=100) {
            document.getElementById('motivator_bar_message').innerText = 'Free UK shipping unlocked!';
        } else {
            document.getElementById('motivator_bar_message').innerText = 'Add £'+ ((5000-cart.total_price)/100).toFixed(2) + ' more to your cart to get free tracked shipping to UK addresses!';
        }
    }

    function do_motivator_bar(cart) {
        //console.log("do_motivator_bar..");
        if(document.getElementById('motivator_bar_disabled') != undefined) {
            console.log("motivator_bar_disabled element found, not showing motivator bar!");
            return;
        }

        percent_complete = (cart.total_price/free_shipping_at) * 100;

        bar1 = document.getElementById('motivator_bar');
        document.getElementById('motivator_bar_host').style.display = 'block';

        update_motivator_bar(cart);
    }

    var currentPageLink = window.location.href;
    
    var should_show = !(
        currentPageLink.includes('/pages/') || 
        currentPageLink.includes('/policies/') || 
        currentPageLink.includes('/blogs/') || 
        currentPageLink.includes('/tools') || 
        currentPageLink.includes('/account') ||
        currentPageLink.includes('auction')
    );
    if (should_show) {
        refresh_motivator();
        subscribe(PUB_SUB_EVENTS.cartUpdate, refresh_motivator);
    }
}
